import { Input, Select } from 'antd';
import classNames from 'classnames/bind';
import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import SearchIcon from 'public/icons/search.svg';
import {
  JOB_FILTER_FIELDS,
  JobFilterField,
  JobFilterOptions,
  JobFilters,
} from 'utils/recruit';
import styles from './JobFilter.module.css';

const cx = classNames.bind(styles);

interface IJobFilterProps {
  search: string;
  filters: JobFilters;
  options: JobFilterOptions;
  onSearchChange: (value: string) => void;
  onFilterChange: (field: JobFilterField, value: string) => void;
}

function JobFilter({
  search,
  filters,
  options,
  onSearchChange,
  onFilterChange,
}: IJobFilterProps) {
  const { t } = useTranslation('recruit-jobs');

  return (
    <div className={cx('filter')}>
      <Input
        className={cx('search')}
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder={t('search-placeholder')}
        allowClear
        prefix={
          <span className={cx('search-icon')}>
            <Image src={SearchIcon} alt="" layout="fill" />
          </span>
        }
      />
      <div className={cx('selects')}>
        {JOB_FILTER_FIELDS.map((field) => {
          const label = `${t(`filter-${field}`)} (${options[field].length})`;
          return (
            <Select
              key={field}
              className={cx('select')}
              value={filters[field] ?? ''}
              onChange={(value) => onFilterChange(field, value)}
              options={[
                { value: '', label },
                ...options[field].map((value) => ({ value, label: value })),
              ]}
            />
          );
        })}
      </div>
    </div>
  );
}

export default JobFilter;
